import { Text } from '@mantine/core'
import { FormattedMessage } from 'react-intl'
import { useRemoveCameraDeployment } from '@/queries/deploymentQueries'
import { DeploymentGroup, DeploymentGroupMember } from '@/types/deploymentGroup'
import { GroupConfirmModal } from './GroupConfirmModal'
import { getMemberCameraName } from './deploymentTreeHelpers'
import { DeploymentTreeGroupContext } from './deploymentTreeTypes'
import { useRunDeploymentAction } from './useRunDeploymentAction'

type MemberRemoveConfirmProps = {
  opened: boolean
  member: DeploymentGroupMember
  group: DeploymentGroup
  context: DeploymentTreeGroupContext
  onClose: () => void
}

export const MemberRemoveConfirm = ({
  opened,
  member,
  group,
  context,
  onClose
}: MemberRemoveConfirmProps) => {
  const { mutateAsync: removeCameraDeployment, isPending } =
    useRemoveCameraDeployment()
  const run = useRunDeploymentAction(onClose)

  const remaining = group.members.length - 1

  const handleConfirm = () =>
    void run(() => removeCameraDeployment(member.deployment_id), {
      inProgress: 'deployments.groups.member.remove.inProgress',
      error: 'deployments.groups.member.remove.error'
    })

  return (
    <GroupConfirmModal
      opened={opened}
      title={<FormattedMessage id="deployments.groups.member.remove.title" />}
      confirmLabel={
        <FormattedMessage id="deployments.groups.member.remove.title" />
      }
      confirmColor="red"
      isPending={isPending}
      onConfirm={handleConfirm}
      onClose={onClose}
    >
      <Text size="sm">
        <FormattedMessage
          id={
            remaining > 0
              ? 'deployments.groups.member.remove.confirmation'
              : 'deployments.groups.member.remove.lastMember'
          }
          values={{
            camera: getMemberCameraName(member, context.device),
            number: context.label,
            count: remaining
          }}
        />
      </Text>
    </GroupConfirmModal>
  )
}
